export const PAGE_CHANGE = 'pageChange';
export const SEARCH_CHANGE = 'searchChange';
export const FILTER_CHANGE = 'filterChange';
